import { useState, useEffect, useCallback } from 'react';
import { playbookApi } from '../api/playbookApi';
import type { PlaybookInstance } from '../types/playbook.types';

export function usePlaybookInstances(matterId: string) {
  const [instances, setInstances] = useState<PlaybookInstance[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!matterId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await playbookApi.listInstances(matterId);
      const data = res as any;
      setInstances(data.instances || []);
    } catch (err) {
      console.error('[usePlaybookInstances] Failed to load instances:', err);
      setError(err instanceof Error ? err.message : 'Failed to load playbook instances');
    } finally {
      setLoading(false);
    }
  }, [matterId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { instances, loading, error, refresh };
}
